import { ENVIRONMENT, APP_LOGGER_MAX_ENTRIES } from "../../../Config/Environment";

const excludedEventsTypesFromLog = ["heartbeat"];
const excludedMessagesFromLog = ["received-statistics"];

function safeClone(value) {
  try {
    return window.structuredClone(value);
  } catch (e) {
    try {
      return JSON.parse(JSON.stringify(value));
    } catch (_) {
      return value;
    }
  }
}

class Logger {
  static instance = null;

  logs = [];
  isSilentHeartbeat = window.localStorage.getItem("silent-heartbeat");
  constructor() {
    this.id = 0;
    this.exposeMethods();
    this.setSilentLogTypes();
  }

  static getInstance() {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }

    return Logger.instance;
  }

  setSilentLogTypes() {
    if (window.localStorage.getItem("silent-heartbeat")) {
      this.isSilentHeartbeat = true;
    }
  }

  exposeMethods() {
    window.toggleHeartbeatLogging = () => {
      const isSilent = window.localStorage.getItem("silent-heartbeat");
      if (isSilent) {
        window.localStorage.removeItem("silent-heartbeat");
        this.isSilentHeartbeat = false;
      } else {
        window.localStorage.setItem("silent-heartbeat", true);
        this.isSilentHeartbeat = true;
      }
    };
  }

  isSilentLog(params) {
    if (this.isSilentHeartbeat) {
      if (params?.[1]?.data?.class === "heartbeat") {
        return true;
      }
    }
    return false;
  }

  log(...params) {
    const getMaxLogCount = () => {
      const max = Number(APP_LOGGER_MAX_ENTRIES);
      if (isNaN(max)) {
        return 1000;
      }
      return max;
    };

    const pushToLog = (...items) => {
      if (this.logs.length >= getMaxLogCount()) {
        this.logs.shift();
      }
      this.logs.push(...items);
    };

    if (ENVIRONMENT !== "prod") {
      if (!this.isSilentLog(params)) {
        console.log(...params);
      }
    }

    const [message, payload] = params;

    if (!excludedEventsTypesFromLog.includes(payload?.data?.class) && !excludedMessagesFromLog.includes(message)) {
      if (params[0] === "received-play_by_play") {
        const seen = new Set();
        for (let i = 0; i < this.logs.length; i++) {
          const item = this.logs[i];
          if (item[0] !== "received-play_by_play") continue;
          const events = item[1];
          if (!Array.isArray(events)) continue;
          for (let j = 0; j < events.length; j++) {
            const ev = events[j];
            if (ev && ev.eventId) {
              seen.add(`${ev.eventId}|${ev.status ?? ""}|${ev.timestamp ?? ""}`);
            }
          }
        }

        const incoming = Array.isArray(params[1]) ? params[1] : [];
        const diff = incoming.filter(
          (event) => !seen.has(`${event?.eventId}|${event?.status ?? ""}|${event?.timestamp ?? ""}`),
        );

        if (diff.length === 0) {
          return;
        }

        pushToLog(["received-play_by_play", safeClone(diff)]);
        return;
      }

      pushToLog(safeClone(params));
    }
  }

  getAllLogs() {
    return JSON.stringify(this.logs);
  }

  resetLogs() {
    this.logs = [];
  }
}

export default Logger;
